'use strict';

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/index.js
// module id = 74
// module chunks = 6